<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" @imp="impt" @del="del" ref="SetBtn"></buttonlist>
		<el-tabs @tab-click="tabclick" v-model="SelectIndexs">
			<el-tab-pane :label="$t('getapi[8213]')" name="0" id="xpane-0">
				<wTable
						:data="dataSet"
						:loading="loading"
						:header="tableHeader"
						@lct="edit"
						queryData="FinReceivablesView"
						:filter_thousandth_salamount="['Money','Total_Amount','Rec_Money','NotRec_Money']"
						:filter_date="['Invoice_Date','Payment_Date']"
						@handleSelectionChange="handleSelectionChange"
						:option="tableOption"
						ref="singleTable"></wTable>
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[8913]')" name="1" id="xpane-1">
				<wTable
						:data="dataSet1"
						:loading="loading"
						:header="tableHeader1"
						queryData="FinReceivablesView"
						:filter_thousandth_salamount="['Money','Total_Amount','Rec_Money','NotRec_Money']"
						:filter_date="['Invoice_Date','Payment_Date']"
						@handleSelectionChange="handleSelectionChange1"
						:option="tableOption"
						ref="singleTable1"></wTable>
			</el-tab-pane>
		</el-tabs>
			<el-row v-if="SelectIndexs == 0" class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<el-row v-if="SelectIndexs == 1" class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange1"
						@current-change="handleCurrentChange1"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize1"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total1"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="FinReceivablesView" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[1030]')" queryData="FinReceivablesView" :tabNo="SelectIndexs" ref="ctab" @getctab="sortclick"></ctable>

		<el-dialog v-dialogDrag :title="$t('getapi[8213]')" :visible.sync="isEditVisible" width="30%">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[2992]')}}</td>
						<td><el-input v-model="rowDetail.Invoice_No" :disabled="true"></el-input></td>
						<td>{{$t('getapi[8472]')}}</td>
						<td><el-input v-model="rowDetail.Proforma_Invoice_No" :disabled="true"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[2102]')}}</td>
						<td><el-input v-model="rowDetail.Money" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
						<td>{{$t('getapi[3861]')}}</td>
						<td><el-date-picker v-model="rowDetail.Payment_Date" type="date" size="mini" style="width:100%"></el-date-picker></td>
					</tr>
					<tr>
						<td>{{$t('getapi[8216]')}}</td>
						<td><el-input v-model="rowDetail.Type" :disabled="true"></el-input></td>
						<td>{{$t('getapi[3099]')}}</td>
						<td><el-input v-model="rowDetail.Create_Person" :disabled="true"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[2950]')}}</td>
						<td><el-input v-model="rowDetail.Create_Date" :disabled="true"></el-input></td>
						<td>{{$t('getapi[2610]')}}</td>
						<td><el-input v-model="rowDetail.Customer_Code" :disabled="true"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[143]')}}</td>
						<td><el-input v-model="rowDetail.Remark" :disabled="true"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isEditVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmEdit">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_finreceivables',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
            dataSet1: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_finreceivables'), // 当前页数据量
			SelectIndexs: '0', //当前页面
			total: 0, // 数据总量
            pageIndex1: 1, // 当前页
            pageSize1: this.$http.getPageSize('3_finreceivables1'), // 当前页数据量
            total1: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
            tableHeader1: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectData: [],
            selectData1: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				copy: false,
				//删除
				delete: false,
			},
            isEditVisible: false,//行编辑弹窗
            rowDetail:{},//行明细
            scrollTop:0,
            scrollTop1:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(that.SelectIndexs)
            })
        },
        dataSet1: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(that.SelectIndexs)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
		let lastmonth = new Date().getMonth() ;
		let thismonth = new Date().getMonth() + 1;
		let myyear = new Date().getFullYear();
		if (lastmonth < 10) {
		lastmonth = '0' + lastmonth;
		}
		if (thismonth < 10) {
		thismonth = '0' + thismonth;
		}
		that.copyparam.startMonth = myyear+"-"+lastmonth;
		that.copyparam.copyMonth = myyear+"-"+thismonth;
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('FinReceivablesView',that.SelectIndexs,PFileds=>{
                if(that.SelectIndexs==0){
                    that.tableHeader=PFileds;
                }
                else if(that.SelectIndexs==1){
                    that.tableHeader1=PFileds;
                }
			});
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8213]"),this.$t("getapi[3846]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
            if (that.$limits.authority('plv3', 557,1) == 0) {
                //查询机
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            }
            else if (that.$limits.authority('plv3', 557,1) == 1) {
                //编辑级
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
            }
            else if (that.$limits.authority('plv3', 557, 1) == 2) {
                //删除级
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
                if(that.selectData.length >0 || that.selectData1.length >0){
                    that.$refs.SetBtn.SetOneBtnEnable('del', true)
                } else {
                    that.$refs.SetBtn.SetOneBtnEnable('del', false)
                }
            }
		},
		btnauthority() {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
            that.selectData = []
			for(let i = 0;i<val.length;i++){
				that.selectData= [...that.selectData,{
                    "Exclusively_Id": val[i].Exclusively_Id,
                    "Invoice_No": val[i].Invoice_No,
                    "Money": val[i].Money,
                    "Payment_Date": val[i].Payment_Date,
                    "Create_Person": val[i].Create_Person,
                    "Create_Date": val[i].Create_Date,
                    "Type": val[i].Type,
                    "Err_Msg": val[i].Err_Msg
				}]
			}
			that.authority()
		},
        handleSelectionChange1(val) {
            let that = this;
            that.selectData1 = []
            for(let i = 0;i<val.length;i++){
                that.selectData1= [...that.selectData1,{
                    "Exclusively_ID": val[i].Exclusively_ID,
                    "Invoice_Code": val[i].Invoice_Code,
                    "Proforma_Invoice_No": val[i].Proforma_Invoice_No,
                    "Invoice_Date": val[i].Invoice_Date,
                    "Total_Amount": val[i].Total_Amount,
                    "CusDue_Date": val[i].CusDue_Date,
                    "Payment_Date": val[i].Payment_Date,
                    "Rec_Money": val[i].Rec_Money,
                    "OldPayment_Date": val[i].OldPayment_Date,
                    "OldRec_Money": val[i].OldRec_Money,
                    "NotRec_Money": val[i].NotRec_Money,
                    "Customer_Name": val[i].Customer_Name,
                    "Customer_Code": val[i].Customer_Code,
                    "Country": val[i].Country,
                    "Audit_Year": val[i].Audit_Year,
                    "Audit_Month": val[i].Audit_Month,
                    "Create_Time": val[i].Create_Time,
                    "Create_Person": val[i].Create_Person
                }]
            }
            that.authority()
        },
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_finreceivables',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
        handleSizeChange1(val) {
            this.pageSize1 = val;
            this.$http.savePageSize('3_finreceivables1',val)
            this.getView();
            this.authority();
        },
        handleCurrentChange1(val) {
            this.pageIndex1 = val;
            this.getView();
            this.authority();
        },
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'FinReceivablesView');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
            that.getView();
		},
        tabclick(tab){
            let that = this;
            console.log(tab.name)
            that.SelectIndexs = tab.name;
            that.$nextTick(function(){
                that.$processdata.initForm(tab.name)
            });
            that.colsort();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			if(that.SelectIndexs == 0){
                that.$http.urlpost('/Finance/FrmSaleInvoice/Fin_Receivables_InfoList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.authority();
                });
			} else if(that.SelectIndexs == 1){
                that.$http.urlpost('/Finance/FrmSaleInvoice/FinRecInfoViewLogList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet1 = res.DataContent;
                        that.total1 = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.authority();
                });
			}
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		del(){
			let that = this;
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    if(that.SelectIndexs == 0){
                        let parm = that.selectData
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Finance/FrmSaleInvoice/DeleteFinReceivablesTransaction', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView();
                            }
                        });
					} else if(that.SelectIndexs == 1){
                        let parm = that.selectData1
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Finance/FrmSaleInvoice/DeleteFinRecInfoViewLog', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView();
                            }
                        });
					}
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });

		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndexs: that.SelectIndexs,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Finance/FrmSaleInvoice/Fin_Receivables_InfoExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "FinReceivablesView",
                fromname: that.$t('getapi[8213]'),
                SelectIndexs: that.SelectIndexs,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
        impt(){
            let item = {
                label: this.$t("getapi[8214]"),
                name: '3_finreceivablesimp',
                path: '/finreceivablesimp',
                url: '/finreceivablesimp',
                icon: 'video-play'
            };
            this.$router.push({path: '/finreceivablesimp'});
            this.$store.commit('selectMenu', item);
		},
		edit(row){
            let that  = this
            that.rowDetail = row.row
            that.isEditVisible = true
		},
        confirmEdit(){
            let that = this
            let parm = that.rowDetail
            that.$http.urlpost('/Finance/FrmSaleInvoice/EditFinReceivablesTransaction', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    that.getView()
                    that.isEditVisible = false
                }
            });
        }
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
